import React from "react";
import {image} from "../../../../utils/data/baseUrl";
import Icon from "../icon/Icon";

export default function CustomHeaderLogo() {
  return (
    <Icon name={"stoloto-logo"}/>
  )
}
